import PageHeader from 'ant-design-pro/lib/PageHeader';
import { Breadcrumb } from 'antd';
import * as moment from 'moment';
import React from 'react';

const content = (
  <div>
    现在时间
    {moment().format('L LTS')}
  </div>
);

const extra = (
  <div className="imgContainer">
    <img style={{ width: '100%' }} alt="" src="https://gw.alipayobjects.com/zos/rmsportal/RzwpdLnhmvDJToTdfDPe.png" />
  </div>
);

export const Home = () => {
  return (
    <>
      <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
        <Breadcrumb.Item>首页</Breadcrumb.Item>
      </Breadcrumb>
      <PageHeader title="欢迎来到聪明派" content={content} extraContent={extra} />
    </>
  );
};



// WEBPACK FOOTER //
// ./src/screens/home/Home.tsx